document.addEventListener('DOMContentLoaded', function () {

  // Select all custom points sections
  var sections = document.querySelectorAll('.custom-points-section');

  sections.forEach(function(section){

    var sectionId = section.dataset.sectionId; // Use data-section-id attribute
    if(!sectionId) return;

    var items = section.querySelectorAll('.customizable__item');
    var dots = section.querySelectorAll('.customizable__dot');
    var mainImages = section.querySelectorAll('.custom-main-image-' + sectionId);
    var currentIndex = 0;

    function activate(index){
      currentIndex = index;

      items.forEach(function(item,i){
        item.classList.remove('active');
        if(i === index) item.classList.add('active');
      });

      dots.forEach(function(dot,i){
        dot.classList.remove('active');
        if(i === index) dot.classList.add('active');
      });

      var activeItem = items[index];
      var desktopImage = activeItem.dataset.image;
      var mobileImage = activeItem.dataset.mobileImage;

      mainImages.forEach(function(img){
        img.style.transition = 'opacity 0.5s ease';
        img.style.opacity = '0';

        setTimeout(function(){
          if(img.classList.contains('hide-on-mobile') && desktopImage){
            img.src = desktopImage;
          }
          if(img.classList.contains('hide-on-desktop') && mobileImage){
            img.src = mobileImage;
          }
          img.style.opacity = '1';
        },200);
      });
    }

    // Click events
    items.forEach(function(item,i){ item.addEventListener('click',function(){ activate(i); }); });
    dots.forEach(function(dot,i){ dot.addEventListener('click',function(){ activate(i); }); });

    // Mobile wrapping
    if(window.innerWidth < 768){
      items.forEach(function(item,i){
        var dot = dots[i];
        if(!dot) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'customizable-wrapper';
        wrapper.setAttribute('data-index',i);

        item.parentNode.insertBefore(wrapper,item);
        wrapper.appendChild(item);
        wrapper.appendChild(dot);

        var rect = wrapper.getBoundingClientRect();
        var screenWidth = window.innerWidth;
        var screenHeight = window.innerHeight;

        var centerX = rect.left + rect.width/2;
        var centerY = rect.top + rect.height/2;

        var horizontal = centerX/screenWidth > 0.7 ? 'right' : centerX/screenWidth < 0.3 ? 'left' : null;
        var vertical = centerY/screenHeight > 0.7 ? 'bottom' : centerY/screenHeight < 0.3 ? 'top' : null;

        if(horizontal && vertical){
          wrapper.classList.add('is-' + vertical + '-' + horizontal);
        } else if(horizontal){
          wrapper.classList.add('is-' + horizontal);
        } else if(vertical){
          wrapper.classList.add('is-' + vertical);
        }
      });
    }

    // Desktop scroll effect
    if(window.innerWidth >= 768){
      var wrapper = section.parentElement;
      var totalItems = items.length;
      wrapper.style.height = section.offsetHeight * totalItems + 'px';

      window.addEventListener('scroll', function(){
        var start = wrapper.offsetTop;
        var end = start + wrapper.offsetHeight - section.offsetHeight;

        if(window.scrollY < start || window.scrollY > end) return;

        var progress = (window.scrollY - start)/(end-start);
        var index = Math.min(totalItems-1, Math.max(0, Math.floor(progress*totalItems)));

        if(index !== currentIndex) activate(index);
      });
    }

  });

});

document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest(".port-close");
  if (!closeBtn) return;

  const item = closeBtn.closest(".customizable__item");
  if (!item) return;

  const index = item.dataset.index;

  item.classList.remove("active");

  const dot = document.querySelector('.port-section__dot[data-index="' + index + '"]');
  if (dot) dot.classList.remove("active");
});